<template>
    <div class="card shadow-sm">

        <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center py-2">
            <h6 class="mb-0">Lista Zgłoszeń</h6>
            <div>
                <button @click="copyEmails" class="btn btn-sm btn-outline-success mr-2" :disabled="loading">
                    📋 Kopiuj E-maile
                </button>
                <button @click="fetchRegistrations(pagination.current_page)" class="btn btn-sm btn-outline-light" :disabled="loading">
                    🔄 Odśwież
                </button>
            </div>
        </div>       

        <!-- <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center py-2">
            <h6 class="mb-0">Lista Zgłoszeń</h6>
            <button @click="fetchRegistrations(pagination.current_page)" class="btn btn-sm btn-outline-light" :disabled="loading">
                🔄 Odśwież
            </button>
        </div> -->
        
        <div class="card-body p-0">
            <div v-if="loading && registrations.length === 0" class="text-center p-5">
                <div class="spinner-border text-primary" role="status"></div>
            </div>

            <div v-else class="table-responsive">
                <table class="table table-hover table-striped mb-0 align-middle small">
                    <thead class="table-light">
                        <tr>
                            <th class="ps-3">Lp.</th>
                            <th>Zawodnik</th>
                            <th>Płeć</th>
                            <th>Kategoria</th>
                            <th>Godzina tury</th>
                            <th>Typ biletu</th>
                            <th>Kontakt</th>
                            <th>Zapisany</th>
                            <th class="text-end pe-3">Akcje</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="registrations.length === 0">
                            <td colspan="8" class="text-center py-4 text-muted">Brak zapisów.</td>
                        </tr>
                        <tr v-for="(row, index) in registrations" :key="row.id">
                            <td class="ps-3 fw-bold">{{ index + 1 }}</td>
                            <td class="fw-bold">{{ row.name }}</td>
                            <td>{{ row.gender === 'male' ? 'M' : 'K' }}</td>
                            <td>{{ row.category ? row.category.name : '-' }}</td>
                            <!-- GODZINA -->
                            <td>
                                <span class="badge bg-secondary">
                                    ⏱️ {{ row.slot ? row.slot.time_string : 'Brak' }}
                                </span>
                            </td>
                            <!-- DARMOWY / PŁATNY -->
                            <td>
                                <span :class="['badge', row.is_free ? 'bg-success' : 'bg-primary']">
                                    {{ row.is_free ? '🎁 Darmowy' : '💰 Płatny' }}
                                </span>
                            </td>
                            <td>
                                <div class="text-muted" style="font-size: 0.8rem;">
                                    <div v-if="row.email">📧 {{ row.email }}</div>
                                    <div v-if="row.phone_no">📞 {{ row.phone_no }}</div>
                                </div>
                            </td>
                            <td>
                                {{ formatDate(row.created_at) }}
                            </td>
                            <!-- PRZYCISK USUWANIA -->
                            <td class="text-end pe-3">
                                <button @click="deleteParticipant(row.id)" class="btn btn-sm btn-danger py-0 px-2" style="font-size: 0.75rem;">
                                    Usuń
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Paginacja (Taka sama jak wczoraj) -->
        <div v-if="pagination.last_page > 1" class="card-footer d-flex justify-content-between align-items-center bg-white py-2">
            <span class="small text-muted">Suma: {{ pagination.total }}</span>
            <nav>
                <ul class="pagination mb-0 pagination-sm">
                    <li :class="['page-item', { disabled: pagination.current_page === 1 }]">
                        <button class="page-link" @click="fetchRegistrations(pagination.current_page - 1)">Poprz.</button>
                    </li>
                    <li v-for="page in pagination.last_page" :key="page" :class="['page-item', { active: page === pagination.current_page }]">
                        <button class="page-link" @click="fetchRegistrations(page)">{{ page }}</button>
                    </li>
                    <li :class="['page-item', { disabled: pagination.current_page === pagination.last_page }]">
                        <button class="page-link" @click="fetchRegistrations(pagination.current_page + 1)">Nast.</button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    data() { return { registrations: [], pagination: {}, loading: false }; },
    mounted() { this.fetchRegistrations(1); },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleString('pl-PL', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        },        
        fetchRegistrations(page) {
            this.loading = true;
            axios.get(`/api/admin/zapisy-dane?page=${page}`)
                .then(res => {
                    this.registrations = res.data.data;

                    this.pagination = { current_page: res.data.current_page, last_page: res.data.last_page, total: res.data.total };
                })
                .finally(() => { this.loading = false; });
        },
        copyEmails() {
            this.loading = true;
            
            axios.get('/api/admin/zapisy-emaile')
                .then(response => {
                    const emails = response.data;
                    
                    if (emails.length === 0) {
                        alert('Brak adresów e-mail do skopiowania.');
                        return;
                    }

                    const textToCopy = emails.join('\r\n');

                    // 1. Próba użycia nowoczesnego API (tylko na HTTPS / Localhost)
                    if (navigator.clipboard && window.isSecureContext) {
                        navigator.clipboard.writeText(textToCopy)
                            .then(() => {
                                alert('Adresy e-mail zostały skopiowane do schowka!');
                            })
                            .catch(err => {
                                console.error('Błąd nowoczesnego API schowka: ', err);
                                this.fallbackCopyText(textToCopy); // W razie błędu idź do starej metody
                            });
                    } else {
                        // 2. Bezpieczny zapas dla zwykłego protokołu HTTP
                        this.fallbackCopyText(textToCopy);
                    }
                })
                .catch(error => {
                    console.error('Błąd pobierania danych: ', error);
                    alert('Wystąpił błąd podczas pobierania adresów e-mail.');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // Starsza metoda kompatybilna ze środowiskiem bez szyfrowania HTTP
        fallbackCopyText(text) {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            
            // Unikamy przewijania strony podczas dodawania elementu
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            textArea.style.opacity = "0";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    console.warn('Do kopiowania adresów e-mail użyto metody zapasowej.');
                    alert('Adresy e-mail zostały skopiowane do schowka!');
                } else {
                    alert('Nie udało się skopiować tekstu.');
                }
            } catch (err) {
                console.error('Błąd metody zapasowej: ', err);
                alert('Błąd systemowy podczas próby kopiowania.');
            }

            document.body.removeChild(textArea);
        },   
        deleteParticipant(id) {
            if (confirm("Czy na pewno chcesz usunąć tego uczestnika? Spowoduje to ewentualny zwrot darmowego miejsca.")) {
                axios.delete(`/api/admin/zapisy/${id}`)
                    .then(res => {
                        alert(res.data.message);
                        this.fetchRegistrations(this.pagination.current_page); // Odśwież bieżącą stronę
                    })
                    .catch(err => alert("Błąd usuwania."));
            }
        }
    }
};
</script>